/**
 * Canonical leg types used in itineraries.
 * Values are stable API payload tokens consumed by multiple providers.
 */
export enum LegType {
    "walk" = "walk",
    "bicycle" = "bicycle",
    "car" = "car",
    "publicTransport" = "publicTransport",
    "rentalMotis" = "rentalMotis",
    "blablacar" = "blablacar",
    "blabladaily" = "blabladaily",
}
